var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuniorFemme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "82px",
    viewBox: "0 0 74 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JuniorFemme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JuniorFemme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6586986,1.29382495 C55.7195809,3.51200891 59.0322328,8.18911788 57.8031167,15.7087556 C56.5740006,23.2283933 59.0306088,32.8518685 67,37.7814395 C65.7072399,39.7814338 56.7071803,34.6417067 54.1851262,32 C51.6630722,29.3582933 50.8002472,24.803019 48.7395003,20.0822361 C46.5577901,15.0843489 43.9645848,13.0995459 43,13.7884926 C45.8219343,18.4526287 48.4559985,23.7103153 50.9021925,29.5615523 C52.6792031,30.2831589 53.764842,32.8186713 53.3856418,35.6258499 C53.0135624,38.380315 51.3550708,40.4789017 49.497994,40.7305515 C47.8904087,46.8240963 43.9288519,51.7356974 38.8346937,54.0561103 L38.8350886,57.4522947 C51.7168604,59.780124 61.023464,67.9961324 61.7299557,77.926792 L61.7505057,78.2621768 L0.961032058,78.2621768 C0.961032058,72.2191492 4.32238903,67.1611153 9.82586212,63.2009375 C13.6321988,60.4619817 18.4428216,58.4456879 23.8261683,57.4625989 L23.8263301,53.1431327 C19.5672792,50.5735889 16.3058728,46.1040411 14.8877528,40.709935 C14.7599167,40.7398411 14.6291063,40.7590503 14.4961011,40.7687274 C12.3302631,40.9262866 10.4026207,38.4966333 10.1905596,35.3419363 C10.1054734,34.0757926 10.3096717,32.8852897 10.7246741,31.9034769 C10.9343746,29.7679788 11.2354609,28.0821546 11.6279945,26.8457069 C12.0411523,25.5442945 14.4690474,18.3382067 17.7345237,15.0294999 C21,11.7207931 24.2429234,10.7970242 30.2469087,10.7970242 C34.2495656,10.7970242 36.0229473,10.654265 35.5670537,10.3687466 C38.2542288,2.84000952 42.2847771,-0.184964362 47.6586986,1.29382495 Z",
    id: "Combined-Shape",
    stroke: "#F6F6F6",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7345237,15.0294999 C21,11.7207931 24.2429234,10.7970242 30.2469087,10.7970242 C34.2495656,10.7970242 36.0229473,10.654265 35.5670537,10.3687466 C38.2542288,2.84000952 42.2847771,-0.184964362 47.6586986,1.29382495 C55.7195809,3.51200891 59.0322328,8.18911788 57.8031167,15.7087556 C56.5740006,23.2283933 59.0306088,32.8518685 67,37.7814395 C65.7072399,39.7814338 56.7071803,34.6417067 54.1851262,32 C51.6630722,29.3582933 50.8002472,24.803019 48.7395003,20.0822361 C46.5577901,15.0843489 43.9645848,13.0995459 43,13.7884926 C46.7875367,20.0485911 50.2366366,27.3779354 53.3472996,35.7765255 L10.4642238,35.7765255 C10.6345108,31.7301098 11.0224344,28.7531702 11.6279945,26.8457069 C12.0411523,25.5442945 14.4690474,18.3382067 17.7345237,15.0294999 Z",
    id: "Path-9",
    fill: "#3D231A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.089665, 13.788493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7449014,38.873839 L38.7454234,43.6638021 C51.7719342,46.0177868 61.1424845,54.3930126 61.6608405,64.4736842 L61.6608405,64.4736842 L0.871366808,64.4736842 C0.871366808,58.4306567 4.23272378,53.3726227 9.73619687,49.4124449 C13.5425336,46.6734891 18.3531563,44.6571953 23.7365031,43.6741063 L23.7364268,38.873839 L38.7449014,38.873839 Z",
    id: "Combined-Shape",
    fill: "#E3B392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2406641,64.0981147 C48.5384066,64.0981147 58.6784654,64.0981147 61.6608405,64.0981147 C61.4949348,60.8716807 60.4222164,57.8199515 58.6130535,55.0844283 C57.8698837,53.9607272 51.7112093,57.5730577 50.7313118,56.5658788 C50.0765327,55.8928699 49.8958612,52.9134768 50.1892974,47.6276996 C48.4137614,46.7402787 47.2341821,46.2129111 46.6505595,46.0455968 C46.2126061,45.9200433 45.6774242,49.2330818 45.045014,55.9847123 C39.7676952,57.005931 35.3282296,57.5165404 31.7266171,57.5165404 C10.0818674,57.5165404 17.206715,47.4612085 17.206715,45.5328831 C14.6061278,46.005397 14.1287954,46.2882909 13.2768571,46.640813 C12.3605748,47.01996 13.9341981,53.1438938 11.9574735,54.5663012 C9.89643814,56.0493768 6.35970399,51.9087018 4.96356197,53.6937942 C2.63166027,56.675339 0.871366808,60.3181842 0.871366808,64.0981147 C4.72201286,64.0981147 14.845112,64.0981147 31.2406641,64.0981147 Z",
    id: "Oval",
    fill: "#E93078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.105909,0 C40.5102948,0 47.5755866,6.61339381 49.603947,15.5747375 C49.7911456,15.5625812 49.9798383,15.5701227 50.1690277,15.5977822 C52.3190185,15.912197 53.7190039,18.705731 53.2959766,21.8373574 C52.9238971,24.5918225 51.2654055,26.6904091 49.4083287,26.9420589 C47.1521128,35.4942352 40.2591384,41.7182663 32.105909,41.7182663 C23.9466174,41.7182663 17.0494556,35.4849763 14.7980875,26.9214424 C14.6702514,26.9513486 14.539441,26.9705577 14.4064359,26.9802348 C12.2405979,27.137794 10.3129555,24.7081407 10.1008943,21.5534437 C9.88889521,18.3987423 11.4727688,15.7136176 13.6386053,15.5560367 C13.9628326,15.53245 14.2817218,15.5668434 14.5903166,15.6529697 C16.5943344,6.65268024 23.6765973,0 32.105909,0 Z",
    id: "Combined-Shape",
    fill: "#F4C6A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.3557689,41.8805978 C32.7122578,41.8805978 33.9403279,41.113054 35.0399794,39.5779663 C33.9403279,39.9095277 32.7122578,40.0753084 31.3557689,40.0753084 C29.99928,40.0753084 28.7712099,39.9095277 27.6715584,39.5779663 C28.7712099,41.113054 29.99928,41.8805978 31.3557689,41.8805978 Z",
    id: "Oval",
    fill: "#F4A76E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3557689,46.903851 C34.0687466,46.903851 36.524887,45.9777886 38.72419,44.1256636 C36.524887,45.1204722 34.0687466,45.6178765 31.3557689,45.6178765 C28.6427912,45.6178765 26.1866508,45.1204722 23.9873478,44.1256636 C26.1866508,45.9777886 28.6427912,46.903851 31.3557689,46.903851 Z",
    id: "Oval",
    fill: "#F4A76E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Yeux",
    transform: "translate(21.224190, 29.446387)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#303030",
    cx: 2.30263158,
    cy: 2.30263158,
    r: 2.30263158
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 1.84210526,
    cy: 1.84210526,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#303030",
    cx: 17.9605263,
    cy: 2.30263158,
    r: 2.30263158
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F2F2F2",
    cx: 17.5,
    cy: 1.84210526,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.10414,34.6476257 C13.0967478,18.2757282 18.5139575,10.0897794 31.3557689,10.0897794 C41.0644158,10.0897794 47.2776516,15.4954215 48.7726742,25.5209094 C48.9200326,26.5090819 49.6531575,28.2276408 49.7154392,29.306367 C49.7370614,29.6808662 48.7613829,29.3038326 48.7726742,29.6891461 C48.8144563,31.1149463 48.6079557,33.2775325 48.1531725,36.1769046 C46.6999561,29.3026145 45.13291,25.2210803 43.4520342,23.9323018 C42.2055556,22.9765889 40.8987134,28.5110643 38.1418306,27.7811547 C37.6482815,27.6504831 39.5937299,21.5650758 38.8345667,18.3598771 C38.608508,17.4054541 36.6018322,22.611201 34.2895126,23.9323018 C34.175195,23.997615 34.0518184,24.0621455 33.9193827,24.1258934 C32.2659535,24.9217706 26.8345171,24.5653014 22.1452426,27.1876056 C19.0190596,28.9358085 16.6720254,31.4224818 15.10414,34.6476257 Z",
    id: "Path-10",
    fill: "#3F2920"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E93078",
    points: "35.5 11.4057352 36.8820847 7.65023351 45.3056213 13.3394218 42.5082644 14.4391256"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 24.5,
    cy: 43.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 26.5,
    cy: 40.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 29.5,
    cy: 40.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 28.5,
    cy: 44.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 44.5,
    cy: 41.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 47.5,
    cy: 39.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 47.5,
    cy: 43.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4A76E",
    cx: 49.5,
    cy: 41.5,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniorFemme);
export default __webpack_public_path__ + "static/media/JuniorFemme.1a0a3c8021bebf659cef5b934ca478e4.svg";
export { ForwardRef as ReactComponent };